import {FC} from 'react'
import {useFormContext} from 'react-hook-form'
import {gql} from '@apollo/client'
import {Body, BodyErrors, BodyItems, ComplementText, Header, Row} from 'components/SearchForm/AdditionalSearchField'
import {SearchTextBox} from 'components/SearchForm/SearchTextBox'
import {SearchSelectBox} from 'components/SearchForm/SearchSelectBox'
import {useQuery} from 'hooks/graphql'
import {toOpts} from 'libs/options'
import {Schema} from '../schema'
import styles from './Languages.scss'

const LANGUAGES = gql`
  query languages {
    client {
      employeeConnections {
        languages {
          id
          name
        }
        languageLevels {
          id
          name
        }
      }
    }
  }
`

interface LanguagesQueryResult {
  client: {
    employeeConnections: {
      languages: {
        id: string
        name: string
      }[]
      languageLevels: {
        id: string
        name: string
      }[]
    }
  }
}

export const Languages: FC = () => {
  const {
    register,
    formState: {errors},
  } = useFormContext<Schema>()

  const {data} = useQuery<LanguagesQueryResult>(LANGUAGES, {fetchPolicy: 'cache-and-network'})
  const languages = data?.client?.employeeConnections?.languages || []
  const languageLevels = data?.client?.employeeConnections?.languageLevels || []

  return (
    <Row>
      <Header>語学</Header>
      <Body className={styles.body}>
        <div>
          <BodyItems>
            <span className={styles.label}>言語</span>
            <SearchSelectBox
              name="languages"
              options={toOpts(languages)}
              width={300}
              placeholder=""
              clearable
              shouldUnregister
            />
          </BodyItems>
        </div>
        <div>
          <BodyItems>
            <span className={styles.label}>レベル</span>
            <SearchSelectBox
              name="languageLevels"
              options={toOpts(languageLevels)}
              width={300}
              placeholder=""
              clearable
              shouldUnregister
            />
          </BodyItems>
        </div>
        <div>
          <BodyItems>
            <span className={styles.label}>資格</span>
            <SearchTextBox {...register('languagesQualificationName', {shouldUnregister: true})} style={{width: 300}} />
          </BodyItems>
          <BodyErrors>
            {errors.languagesQualificationName && <p>{errors.languagesQualificationName.message}</p>}
          </BodyErrors>
        </div>
        <div>
          <BodyItems>
            <span className={styles.label}>点数</span>
            <SearchTextBox
              {...register('languagesScoreFrom', {shouldUnregister: true})}
              style={{width: 60}}
              maxLength={6}
            />
            <ComplementText>点以上</ComplementText>
            <SearchTextBox
              {...register('languagesScoreTo', {shouldUnregister: true})}
              style={{width: 60}}
              maxLength={6}
            />
            <ComplementText>点以下</ComplementText>
          </BodyItems>
          <BodyErrors>
            {errors.languagesScoreFrom && <p>{errors.languagesScoreFrom.message}</p>}
            {errors.languagesScoreTo && <p>{errors.languagesScoreTo.message}</p>}
          </BodyErrors>
        </div>
      </Body>
    </Row>
  )
}
